import type { UIComponent, Feed } from '../layout/index.ts';

export function getPluginIdentifier(
  cellStyles: any,
  cellId: string
): string | undefined {
  return cellStyles[cellId]?.plugin_identifier;
}

/**
 * Determines if the feed for both user specific or general components
 * should be loaded on the client side.
 * For example, "continue-watching" and "favorites" components
 * or components with rules to load feed from client.
 * @param uiComponent UIComponent
 * @returns true if the feed should be loaded on the client side
 */
export function getIsClientLoaded(uiComponent: UIComponent) {
  return (
    uiComponent?.data?.source?.startsWith('pipesv2://') ||
    isLoadFeedFromClient(uiComponent)
  );
}

export const actionToComponentType: Record<
  string,
  'continue-watching' | 'favorites'
> = {
  'pipesv2://continue-watching': 'continue-watching',
  'pipesv2://local_storage_favourites_action_web': 'favorites',
  'pipesv2://local_storage_favourites_action': 'favorites',
} as const;

export function isLoadFeedFromClient(uiComponent: UIComponent): boolean {
  return (
    !!(
      uiComponent?.rules?.load_feed_from_client ||
      uiComponent?.rules?.load_feed_from_client_switch
    ) && !isEnableDataRefreshing(uiComponent)
  );
}

export function isEnableDataRefreshing(uiComponent: UIComponent): boolean {
  return !!(
    uiComponent?.rules?.enable_data_refreshing ||
    uiComponent?.rules?.enable_data_refreshing_switch
  );
}

export function isServerAbortedFeed(feed: Feed | null | undefined): boolean {
  if (!feed) return false;
  return !!(feed?.statusCode === 408 && feed?.isServerAbortedFeed);
}
